module.exports = __webpack_public_path__ + "static/images/3e8fc1aa57e52bd4fc4708ba80b84108.png";